import { OpenAPI } from '/src/api';
import { getApiUrl } from '/src/api/core/request';

export type TCalculateCreditsRequest = {
  start_reporting_quarter: string;
  program_ids: number[];
  client_ids?: number[];
  skip_equipment_missing_kwh: boolean;
};

export type TMissingEquipmentItem = {
  client: string;
  facility: string;
  serial_number: string;
};

export type TMissingDataResponse = {
  message: string;
  finalized_reporting_periods: { client: string; program: string }[];
  missing_cixd_standards: { program: string; baseline_fuel_type: string }[];
  missing_equipment_type_eers: { program: string; equipment_type: string }[];
  equipment_missing_fuel_pathways: TMissingEquipmentItem[];
  equipment_missing_kwh: TMissingEquipmentItem[];
};

export class CalculateCreditsService {
  /**
   * Run a bulk credit calculation. Validation errors return as JSON; on success the
   * response streams SSE events (line, then done/failed/cancelled) until completion.
   * Aborting the request cancels the calculation server-side.
   * @param req TCalculateCreditsRequest
   * @returns Response
   */
  public static calculate(req: TCalculateCreditsRequest, signal?: AbortSignal): Promise<Response> {
    const token = typeof OpenAPI.TOKEN === 'string' ? OpenAPI.TOKEN : undefined;

    return fetch(`${getApiUrl()}/calculateCredits`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/event-stream',
        ...(token !== undefined ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(req),
      signal,
      ...(OpenAPI.USE_CREDENTIALS ? { credentials: OpenAPI.CREDENTIALS as RequestCredentials } : {}),
    });
  }
}
